import React, { SetStateAction } from 'react'
import { useSelector } from 'react-redux'
import { Button } from '../../../../../common/components/button/Button'
import { PromoInterface } from '../../../../../common/types/interfaces'
import { selectClusterImageUrl } from '../../../../../store/slices/currentClusterSlice'
import { useMailingConfirm } from './useMailingConfirm'
import styles from './MailingConfirmContent.module.scss'

type Props = {
  current?: PromoInterface
  setModalActive: React.Dispatch<SetStateAction<boolean>>
  getList: ()=>void
}

export const MailingConfirmContent: React.FC<Props> = ({ current, setModalActive, getList }) => {
  const { confirmMailing } = useMailingConfirm(getList, setModalActive, current)
  const imageUrl = useSelector(selectClusterImageUrl)

  if (!current) return null

  return (
    <div className={styles.container}>
      <div className={styles.title}>🚀 Запуск рассылки</div>

      <div className={styles.message}>
        Вы собираетесь начать рассылку акции <strong>«{current.name}»</strong>
      </div>

      {current.files?.[0] && (
        <img className={styles.image} src={imageUrl + current.files[0]} alt={current.name} />
      )}

      {current.description && (
        <div className={styles.description}>
          <strong>Описание:</strong> {current.description}
        </div>
      )}

      {current.datesImportant && current.startDate && current.endDate && (
        <div className={styles.dates}>
          📅 {new Date(current.startDate).toLocaleDateString()} —{' '}
          {new Date(current.endDate).toLocaleDateString()}
        </div>
      )}

      {current.discount ? (
        <div className={styles.discount}>💰 Скидка {current.discount}%</div>
      ) : (
        <div className={styles.info}>ℹ️ Информационное сообщение</div>
      )}

      {current.useDiscountCode && current.discountCode && (
        <div className={styles.promocode}>🎫 Промокод: {current.discountCode}</div>
      )}

      <div className={styles.warning}>⚠️ Отменить или остановить рассылку будет невозможно</div>

      <div className={styles.buttons}>
        <Button text="Отмена" onClick={() => setModalActive(false)} />
        <Button text="Подтвердить" onClick={confirmMailing} />
      </div>
    </div>
  )
}